import './index.scss'
import { SectionHeader } from '../Headlines'
import { Video } from '../Video'
import { Header } from './Header'
import { Intro } from './Intro'
import { Team } from './Team'
import { Goals } from './Goals'
import { ColorUnderwater } from './ColorUnderwater'
import { IdentifyingCuttlefish } from './IdentifyingCuttlefish'
import { DataExplorer } from '../DataExplorer'
import { useBreakpointContext } from '../../util/BreakpointProvider'
import React, { useState } from 'react'

export function ExpeditionsPage({ content, downloadLink }) {
  const { isMobile, isTablet } = useBreakpointContext()
  const [isExplorerOpen, setIsExplorerOpen] = useState(false)

  return (
    <div className='expeditionspage'>
      <Header content={content} isMobile={isMobile} isTablet={isTablet} />
      
      <Intro content={content} />

      <ColorUnderwater content={content} />

      <Team content={content} />


      <IdentifyingCuttlefish content={content} />

      <Goals content={content} />

      <section className='container inset no-border'>
        <SectionHeader title="Setting the scene" topBorder />
        <div className='video-top'>
          <Video src={`https://player.vimeo.com/video/${content.scene.video}?background=1`} />
          <div class="caption" style={{
            position: 'absolute',
            top: '5%',
            left: '3%',
            background: 'black',
            borderRadius: '15px',
            padding: '16px',
            width: '400px',
            
          }}>

          <p>Anilao is a small diving area located in the Batangas region of the Philippines. It lies within the Verde Island Passage – one of the most biodiverse marine areas on Earth.</p>
          </div>
        </div>

        

      </section>

      {/* Explore our data section */}
      <section className='container inset bottom-padded' id='explore-data'>
        <SectionHeader title="Explore our data" topBorder/>
        
        <div className='explore-data padded'>
          <div className='image'>
            <img src={`assets/expeditionspage/coming-soon-${isMobile || isTablet ? "mobile" : "desktop"}.png`} alt="coming soon" />
          </div>
 

          <div className="skinny dashed-border explore-data-link">
            <button onClick={() => setIsExplorerOpen(true)} className="center no-underline" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--theme-color)' }}>
              <span>Explore the data</span>
              <img src="assets/expeditionspage/arrow-right.svg" alt="arrow right" />
            </button>
          </div>
          <div className="skinny dashed-border explore-data-link">
            <a href="https://onlinelibrary.wiley.com/doi/10.1002/ece3.72001" target="_blank" rel="noopener noreferrer" className="center no-underline" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--theme-color)' }}>
              <span>Read our publication</span>
              <img src="assets/expeditionspage/arrow-right.svg" alt="arrow right" />
            </a>
          </div>
        </div>
      </section>

      {/* Next steps section */}
      <section className='inset no-border'>
        <SectionHeader title="Next steps" />
       
        <div className='narrow'>
          <div className='vstack padded'>
            <p className='center'>
              {content.nextsteps.intro}
            </p>
            <div className="margin-block">
            <div className='vstack padded'>
              {content.nextsteps.items.map((item, index) => (
                <React.Fragment key={index}>
                  <h3 className='center'>
                    {item.text}
                  </h3>
                  {index < content.nextsteps.items.length - 1 && <div className="divider" />}
                </React.Fragment>
              ))}
            </div>
            </div>
            <p className='center'>
              {content.nextsteps.cta} 
            </p>
            <p className='center -bold'>
              Please write to us → <a href={`mailto:${content.nextsteps.email}`}>{content.nextsteps.email}</a>
            </p>
          </div>
        </div>
      </section>

      {/* Data Explorer Modal */}
      {isExplorerOpen && (
        <DataExplorer 
          isOpen={isExplorerOpen}
          onClose={() => setIsExplorerOpen(false)}
          observations={content.observations}
        />
      )}

    </div>
  )
}